import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Wallet } from "lucide-react";
import { adminApi, errorMessage } from "../../lib/api";
import { inr, usePricing } from "../landing/usePricing";
import { UpiPay } from "../payments/UpiPay";

export const WalletCard = ({ account, refresh, onChange }) => {
  const pricing = usePricing();
  const [txns, setTxns] = useState([]);
  const [pending, setPending] = useState([]);
  const [amount, setAmount] = useState(null);
  useEffect(() => {
    adminApi.get("/employer/wallet/transactions").then((r) => setTxns(r.data)).catch(() => {});
    adminApi.get("/employer/wallet/upi").then((r) => setPending(r.data.filter((p) => p.status === "pending"))).catch(() => {});
  }, [refresh]);

  const recharge = (a) => setAmount(a);

  return (
    <section data-testid="wallet-card" className="grid grid-cols-1 gap-6 border border-white/10 bg-[#0F172A] p-6 lg:grid-cols-2">
      <div>
        <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.15em] text-slate-400"><Wallet className="h-4 w-4" />Wallet balance</p>
        <p data-testid="wallet-balance" className={`mt-2 font-heading text-4xl font-extrabold ${account.balance < 0 ? "text-red-400" : "text-white"}`}>{inr(account.balance)}</p>
        {pricing.mode === "free" ? (
          <p className="mt-3 text-sm text-emerald-300">The platform is currently free — no unlock fee or commission is charged.</p>
        ) : (
          <p className="mt-3 text-sm text-slate-400">Contact unlock: {inr(pricing.unlock_fee)} · Monthly commission per hired worker as per role.</p>
        )}
        <p className="mt-5 text-xs font-semibold uppercase tracking-wider text-slate-400">Recharge by UPI</p>
        {amount && <UpiPay open amount={amount} note="Wallet recharge" path="/employer/wallet/upi" body={{ amount }} onClose={() => setAmount(null)}
          onDone={() => { setAmount(null); onChange(); }} testId="wallet-upi" />}
        {pending.map((p) => <p key={p.created_at} data-testid="wallet-upi-pending" className="mt-2 text-sm text-amber-300">{inr(p.amount)} recharge: waiting for UPI payment of ₹{Number(p.pay_amount || p.amount).toFixed(2)}.</p>)}
        <div className="mt-2 flex flex-wrap gap-2">
          {pricing.wallet_options.map((a) => (
            <button key={a} onClick={() => recharge(a)} data-testid={`wallet-recharge-${a}`}
              className="bg-orange-500 px-4 py-2 text-sm font-semibold text-white hover:bg-orange-600">Add {inr(a)}</button>
          ))}
        </div>
      </div>
      <div className="max-h-64 overflow-y-auto">
        <p className="mb-2 font-mono text-[11px] uppercase tracking-[0.15em] text-slate-400">Transactions</p>
        {txns.length === 0 && <p className="text-sm text-slate-500">No transactions yet.</p>}
        {txns.map((t) => (
          <div key={t.created_at + t.note} data-testid="wallet-txn" className="flex justify-between gap-3 border-b border-white/5 py-2 text-sm">
            <span><span className="text-slate-200">{t.note}</span><br /><span className="text-xs text-slate-500">{new Date(t.created_at).toLocaleString("en-IN")}</span></span>
            <span className={`whitespace-nowrap font-mono ${t.amount < 0 ? "text-red-300" : "text-emerald-300"}`}>{t.amount < 0 ? "−" : "+"}{inr(Math.abs(t.amount))}</span>
          </div>
        ))}
      </div>
    </section>
  );
};
